import React from 'react';

import { usePostOfficePlacement } from '../../../common/usePostOfficePlacement';


const ClientSideOnly = ({ children }: React.PropsWithChildren): React.JSX.Element | null =>
	typeof window !== 'undefined' ? <>{children}</> : null;

export const AudioSpotlightTour = (): React.ReactElement | null => {
	const { PostOfficePlacement } = usePostOfficePlacement();

	if (!PostOfficePlacement) {
		return null;
	}

	return (
		<ClientSideOnly>
			<PostOfficePlacement placementId={'cc-ai-audio-playback-spotlight-tour'} />
		</ClientSideOnly>
	);
};
